import { LANG_ENTRY_TYPES } from "../../Data/consts";
import { LANG_V2_REC, REC, SUB } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { recommendation_schema_names } from "./utils";


/*
{
  _id
  _mastercategory: LanguageData
  _lang_v2: parent id
  type: 'mastercategories'

}
*/

export class Recommendation extends LanguageCategory {
  constructor(data) {
    super(data)
    // this.changed = false
    this.type = Recommendation.getTypeDir()
    this.childTypes = Recommendation.getChildTypes()

  }

  toOldLangEntry() {
    let { short, eul, unitType, high, med, low, content, _name } = this
    return {
      [`!${recommendation_schema_names.SHORT}`]: short,
      [`!${recommendation_schema_names.EUL}`]: eul,
      [`!${recommendation_schema_names.UNIT_TYPE}`]: unitType,
      [`!${recommendation_schema_names.HIGH}`]: high,
      [`!${recommendation_schema_names.LOW}`]: low,
      [`!${recommendation_schema_names.MED}`]: med,
      _mask: content,
      _name
    }
  }

  getDisplayText() {
    return this.short
  }

  getFormData() {
    return LanguageCategory.getFormData(Recommendation, this)
  }

  static getFormKeys() {
    return [recommendation_schema_names.SHORT, recommendation_schema_names.CONTENT, recommendation_schema_names.EUL, recommendation_schema_names.UNIT_TYPE, recommendation_schema_names.HIGH, recommendation_schema_names.LOW, recommendation_schema_names.MED, recommendation_schema_names.TAG]
  }

  static getTypeDir() {
    return REC
  }

  static getRelType() {
    return LANG_V2_REC
  }

  static getFormColWidths() {
    return {
      parent: 2,
      [recommendation_schema_names.SHORT]: 2,
      [recommendation_schema_names.CONTENT]: 2,
      [recommendation_schema_names.EUL]: 1,
      [recommendation_schema_names.UNIT_TYPE]: 1,
      [recommendation_schema_names.HIGH]: 1,
      [recommendation_schema_names.LOW]: 1,
      [recommendation_schema_names.MED]: 1,
      [recommendation_schema_names.TAG]:1
    }
  }

  getTypeAddress() {
    return LanguageCategory.getTypeAddress(Recommendation)
  }
  static getChildTypes() {
    return []
  }
  static getParentKey() {
    return SUB
  }
  static getParentAddress() {
    return super.getParentAddress(Recommendation)
  }

  static constructFromDBData(data) {
    return new Recommendation(super.constructFromDBData(data, Recommendation.getTypeDir()))

  }

  static getFormSchema(mapTagOptions= ()=>{}) {
    return [
      { name: recommendation_schema_names.SHORT, required: true, as: 'textarea', rows:4 },
      { name: recommendation_schema_names.CONTENT, required: true, as: 'textarea', rows:4},
      { name: recommendation_schema_names.EUL, type: 'text'},
      { name: recommendation_schema_names.UNIT_TYPE, type: 'text'}, 
      { name: recommendation_schema_names.HIGH, type: 'text'} ,
      { name: recommendation_schema_names.MED, type: 'text'} ,
      { name: recommendation_schema_names.LOW, type: 'text'} ,
      { name: recommendation_schema_names.TAG, required: true, as: 'select', children: mapTagOptions(LANG_ENTRY_TYPES) },
    ]
  }

  static getMongooseSchema(mongoose, Schema) {
    return super.getMongooseSchema(mongoose, Schema, {
      [super.getParentAddress(Recommendation)]: { type: mongoose.ObjectId, ref: Recommendation.getParentKey(), required: true },
      short: { type: String, required: true },
      eul: { type: Number },
      unitType: { type: String },
      high: { type: Number },
      med: { type: Number },
      low: { type: Number },
      tag: { type: String, enum: LANG_ENTRY_TYPES }
    }, Recommendation.getTypeDir())
  }
}